import React, { PureComponent } from 'react';
import { fetchInitialNewPasswordData, fetchInitialSetPasswordData } from '../../../../authentication/api';
import { actionTypeEnum } from '../../../consts';

const AuthenticationFetchNewPassword = (OriginalComponent) =>
	class extends PureComponent {
		state = {
			isPending: true,
			passwordRules: {},
		};

		componentDidMount() {
			const apiFunction =
				this.props.actionType === actionTypeEnum.NEW_PASSWORD
					? fetchInitialNewPasswordData
					: fetchInitialSetPasswordData;

			apiFunction().then(this.handleLoginSuccess).catch(this.handleLoginError);
		}

		handleLoginSuccess = ({ data }) => {
			if (data.email) {
				this.props.setPreviewLoginFormEmail(data.email);
			}

			this.setState({
				passwordRules: data,
				isPending: false,
			});
		};

		handleLoginError = ({
			response: {
				data: { errors },
			},
		}) => {
			if (errors._.sessionExpired) {
				this.props.authenticationSetActionType(actionTypeEnum.SESSION_EXPIRED);
			}

			this.setState({
				isPending: false,
			});

			this.props.authenticationSetActionType(actionTypeEnum.SORRY_AN_ERROR_OCCURRED);
		};

		render() {
			return (
				<OriginalComponent
					{...this.state}
					{...this.props}
				/>
			);
		}
	};

export default AuthenticationFetchNewPassword;
